/**
 * Feature detection for graceful degradation.
 *
 * - isTouch — coarse pointer, disables custom cursor and fishing interaction
 * - reducedMotion — respects prefers-reduced-motion; disables ambient animations
 * - isMobile — viewport width heuristic; halves particle counts
 * - dpr — clamped device pixel ratio (capped at 2 to avoid 3x retina tax)
 * - fishingEnabled — derived: fishing only runs on non-touch, non-reduced-motion
 */

export interface Env {
  isTouch: boolean
  reducedMotion: boolean
  isMobile: boolean
  dpr: number
  fishingEnabled: boolean
}

export function detectEnv(): Env {
  const isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const isMobile = window.matchMedia('(max-width: 768px)').matches
  const dpr = Math.min(window.devicePixelRatio || 1, 2)
  const fishingEnabled = !isTouch && !reducedMotion

  return { isTouch, reducedMotion, isMobile, dpr, fishingEnabled }
}
